import React from 'react';
import { LinkedinFilled, GithubFilled, MailFilled, } from '@ant-design/icons'
import { GeneralContainer } from '../styles/styled.components';

const styles = {
    footer: {
        display: 'flex', 
        justifyContent: 'right',
        flexDirection: 'row',
        padding: '0rem 1rem 1rem 0rem'
    },
    margin: {
        margin: '0 auto',
        
    },
    icons: {
        marginLeft: '1rem',
        textDecoration: 'none',
        fontSize: '20px',
    },
    border: {
        position: 'relative',
        display: 'flex',
        borderTop: 'solid gray'
    }
}

export default function Footer () {
    const currentYear = new Date().getFullYear();
    return (
        <div style={styles.border}>
            <div style={styles.margin}>
                <div style={{ marginTop: '.3rem', position: 'absolute' }}>
                    © {currentYear} Bleh Seton
                </div>
            </div>
            <div style={styles.footer}>
                <div style={styles.icons}><GeneralContainer target="_blank" rel="noreferrer" href='https://github.com/Blehjo'><GithubFilled /></GeneralContainer></div>
                <div style={styles.icons}><GeneralContainer target="_blank" rel="noreferrer" href='https://www.linkedin.com/in/bleh-s/'><LinkedinFilled /></GeneralContainer></div>
                <div style={styles.icons}><GeneralContainer href='mailto:blehjooo@gmail.com'><MailFilled /></GeneralContainer></div>
            </div>
        </div>
    )
}